export enum Role {
  Kiosk = 'KIOSK',
  Operator = 'OPERATOR',
  Manager = 'MANAGER',
  FirmwareEngineer = 'FIRMWARE_ENGINEER',
  Technician = 'TECHNICIAN',
}
